
import { useEffect, useState } from "react"
import ImageLibraryTable from "./ImageLibraryTable"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";


interface Props {
    modalOpen : boolean;
    toggleModal : () => void;
    getSelected : (id : string) => void;
}

export default function ImageLibrarySelectorModal ({modalOpen , toggleModal, getSelected} : Props) {

    const [selected, setSelected] = useState<string>("");

    const SelectImage = (id : string) => {
        setSelected(id);
    }

    const CloseModal = () => {
        setSelected("");
        toggleModal();
    }

    const ConfirmSelected = () => {
        getSelected(selected);
        toggleModal();
    }

    useEffect(() => {
        if(modalOpen === false) {
            setSelected("");
        }
    },[modalOpen])

    return (
        <Modal
            id="video-selector-modal"
            className="modal-xl"
            backdrop={true}
            isOpen={modalOpen}>
            <ModalHeader toggle={toggleModal} className="pb-0">
                <p className="text-lg">Select Image from Library</p>
            </ModalHeader>
            <ModalBody>
                <ImageLibraryTable
                    limit={5}
                    haveActions={true}
                    select={SelectImage}
                    selectedValue={selected}

                />

            </ModalBody>
            <ModalFooter>
                <ModalFooter className="d-flex justify-content-end">
                    <Button color="secondary" onClick={CloseModal} >Close</Button>
                    <Button color="primary" onClick={ConfirmSelected} disabled={selected === ""} >Confirm</Button>
                </ModalFooter>
            </ModalFooter>
        </Modal>
    )
}

